import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms'
import { RegistrationService } from '../registration.service'
import { User } from '../user';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit  {
  msg='';
  user=new User();
  isLoading = false;

  constructor(private  _service : RegistrationService, private _route : Router, private authService: AuthService) { }

  ngOnInit(): void {
  }

  doLogin() {
    if (!this.user.username || !this.user.password) {
      this.msg = 'Please provide username and password';
      return;
    }

    this.isLoading = true;
    const resp = this._service.login(this.user);
    resp.subscribe(
      token => {
        this.user.successMessage = token;
        this.authService.setLoggedIn(true);
        this._route.navigate(['/table-list']);
        this.isLoading = false;
      },
      err => {
        console.error('Login failed', err);
        this.msg = 'Login failed. Please check your credentials and try again.';
        this.isLoading = false;
      }
    );
  }
   goRegistration()
   {
    this._route.navigate(['/registration'])
   }

  addUser(form :any)
  {
    console.log(form.value);

  }

  loginUser()
  {
  
    this._service.loginUserFromRemote(this.user).subscribe(
      data => {console.log('Response Recived',data)
      if(data!=null)
      this._route.navigate(['/home'])
      else
      error => console.log('Exception ocurred',error)
      this.msg='bad credential please enter valid email id and password';
    }
    ) 
   }
 
}